module.exports = __webpack_public_path__ + "static/img/banner-2.1683496d.png";